import Vue from 'vue'

export default Vue.extend({
  data() {
    return {
      downloadingPdf: false,
    }
  },
  computed: {
    fullName() {
      if (!this.hasRedeemableVoucher) {
        return ''
      }
      return `${this.redeemableVoucher.firstName} ${this.redeemableVoucher.lastName}`
    },
    redeemableVouchers() {
      return this.$store.getters['sales/redeemableVouchers']
    },
    redeemableVoucher() {
      return this.redeemableVouchers[0]
    },
    hasRedeemableVoucher() {
      return !!this.redeemableVouchers && this.redeemableVouchers.length > 0 && 'id' in this.redeemableVouchers[0]
    },
    voucherSale() {
      return this.$store.getters['sales/purchase']
    },
    voucherValueText() {
      let amountAndCurrency = this.$options.filters.formatCurrency(this.redeemableVoucher.amount, this.redeemableVoucher.currency)
      if (this.redeemableVouchers.length > 1) {
        amountAndCurrency = `${amountAndCurrency} x ${this.redeemableVouchers.length}`
      }
      return amountAndCurrency
    },
  },
  watch: {
    redeemableVoucher: {
      immediate: true,
      handler() {
        if (typeof this.redeemableVoucher === 'object') {
          if (!this.hasRedeemableVoucher) {
            this.$router.push({
              name: 'voucherSaleLanding',
            })
          }
        }
      },
    },
  },
  methods: {
    async downloadPdf() {
      this.downloadingPdf = true

      try {
        await this.downloadFile('/vouchers/voucher_sale.pdf', { id: this.voucherSale.id })
      } finally {
        this.downloadingPdf = false
      }
    },
  },
})
